import React from 'react';
import {OrderProductMaterialBodyProps} from '@views/orders/fields/products/extra_row/materials/.types';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const Body = React.lazy(() => import('@views/orders/fields/products/extra_row/materials/Body'));

export default function LazyBody(props: OrderProductMaterialBodyProps) {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <Body {...props}/>
    </React.Suspense>;
}
